import createDialog from './createDialog';
import Dialog from './dialog.vue';
var dialog = createDialog(Dialog);
dialog.create = createDialog;
export default dialog;